var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m336.835 54.806c-.831-.634-8.527-6.359-22.236-11.868-17.661-7.098-37.926-10.85-58.603-10.85s-40.941 3.752-58.604 10.85c-13.708 5.509-21.404 11.234-22.236 11.869-4.174 3.183-6.624 8.132-6.624 13.381v26.401l16.827 9 16.828-9v-16.872c9.235-4.713 27.703-11.975 53.808-11.975 26.106 0 44.573 7.262 53.808 11.975v16.871l16.827 9 16.828-9v-26.4c.002-5.25-2.448-10.199-6.623-13.382z",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d66e41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.533 94.589v18.58l16.828 9 16.828-9v-18.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.46 94.589h-33.655v18.58l16.828 9 16.827-9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m13.247 298.286v149.492c0 17.747 14.387 32.134 32.134 32.134h421.238c17.747 0 32.134-14.387 32.134-32.134v-149.492z",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.247 279.706v18.581c26.696 21.196 97.252 62.343 242.753 62.343s216.057-41.147 242.753-62.344v-18.581h-485.506z",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.852 269.005c25.585 20.83 96.043 63.464 244.148 63.464s218.562-42.634 244.148-63.464c7.5-6.106 11.852-24.256 11.852-33.927v-89.775c0-17.747-14.387-32.134-32.134-32.134h-447.732c-17.747 0-32.134 14.387-32.134 32.134v89.775c0 9.671 4.352 27.821 11.852 33.927z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.148 260.005c-25.585 20.83-96.043 63.464-244.148 63.464s-218.562-42.635-244.148-63.464c-7.5-6.106-11.852-15.256-11.852-24.927v18.581c0 9.671 4.352 18.821 11.852 24.927 25.585 20.83 96.043 63.464 244.148 63.464s218.562-42.634 244.148-63.464c7.5-6.106 11.852-15.256 11.852-24.927v-18.581c0 9.671-4.352 18.821-11.852 24.927z",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.997 372.974c16.624 0 30.1-12.344 30.1-39.1v-18.25c0-5.916-4.796-10.711-10.711-10.711h-38.778c-5.916 0-10.711 4.796-10.711 10.711v18.253c-.001 26.753 13.476 39.097 30.1 39.097z",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.997 363.974c-16.624 0-30.1-13.476-30.1-30.1v18.581c0 16.624 13.476 30.1 30.1 30.1s30.1-13.476 30.1-30.1v-18.581c0 16.623-13.476 30.1-30.1 30.1z",
    fill: "#f9cf58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissions);
export default __webpack_public_path__ + "static/media/missions.09a9d86771732d925394414960d77856.svg";
export { ForwardRef as ReactComponent };